import { render, staticRenderFns } from "./StoreDescription.vue?vue&type=template&id=5733a5be"
import script from "./StoreDescription.vue?vue&type=script&lang=js"
export * from "./StoreDescription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports